import React from 'react';
import { TypedMemo } from '../../../common/types';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './PromoteChannels.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ChannelsSectionHeadProps {
  title: string;
  subtitle: string;
}

/** The heading of one part of Channels: social channels, then data channels. */
const ChannelsSectionHeadComponent: React.FC<ChannelsSectionHeadProps> = ({ title, subtitle }) => (
  <div className={styles.sectionHead}>
    <h2 className={styles.sectionTitle}>{title}</h2>
    <p className={styles.sectionSub}>{subtitle}</p>
  </div>
);

export const ChannelsSectionHead = TypedMemo(ChannelsSectionHeadComponent);
